<app-modal-container
  [formGroup]="metricsGroup"
  [title]="(modalType === 'create' ? 'Create ' : 'Edit ') + 'metric group'"
  [buttons]="showFirstExplanationModal ? { close: true } : modalButtons"
  [applyActivated]="this.metricsGroup?.valid"
  (dismissButtonClicked)="close()"
  (closeButtonClicked)="close()"
  (applyButtonClicked)="confirm()"
  (lowerLeftButtonClicked)="initDeleteMetricGroup()">
  @if (metricsGroup) {
    @if (showFirstExplanationModal){
      <app-kpi-metric-group-data-type-selector
        (dataTypeEmitter)="selectMetricGroupDataType($event)"
      />
    } @else {
      <div class="flex flex-col w-[50rem] gap-[1rem]">
        <div class="flex w-full gap-[1rem] items-start">
          <div class="w-[18rem]">
            <app-selector
              data-qa="metric-group-type"
              class="width-100pcnt"
              [title]="'Type'"
              [isNotInTable]="true"
              [data]="metricGroupTypes"
              [selectedItem]="metricGroupTypes[metricGroupTypes.indexOf(metricGroupType)]"
              (itemEmitter)="changeModalType($event, true)"
            />
          </div>
          <div class="flex-auto">
            <app-input
              data-qa="input-group-name"
              placeholder="Group name"
              formControlName="name"
              [required]="true"
              [additionalClass]="!metricsGroup.controls.name.valid ? 'error' : ''"
              [bottomText]="groupErrorMessage"
              [title]="'Group name'">
            </app-input>
          </div>
        </div>
        <div class="grey-line"></div>
        @if (metricGroupType === 'Numbers with balances') {
          <div class="space-between-horizontal-centered row-gap-1 w-[45rem]" [formGroup]="starting">
            <app-checkbox
              data-qa="checkbox-starting-metric"
              class="w-[1.5rem]"
              formControlName="isSelected"
              (checkBoxClicked)="handleChange(starting, ending, true)">
            </app-checkbox>
            <app-input
              class="w-[17.75rem]"
              [placeholder]="'Sum (previous period)'"
              [prefixFirstIcon]="'sum.svg'"
              [additionalClass]="'disabled'"
            />
            <div class="w-[30rem]">
              <app-input
                data-qa="input-starting-name"
                formControlName="name"
                placeholder="Starting name"
                [additionalClass]="!starting.value?.isSelected ? 'disabled' : ''">
              </app-input>
            </div>
          </div>
        }

        <div cdkDropList (cdkDropListDropped)="drop($event)" formArrayName="metrics">
          @for (metric of metricsGroup?.controls.metrics.controls; track metric; let i = $index) {
            <div
              cdkDrag
              cdkDragPreviewClass="cdk-drag-preview"
              [cdkDragData]="metric"
              [formGroupName]="i">
              <div class="vertical-container-simple">
                <div class="draggable start-start-row-container row-gap-1 pd-top-0p5">
                  <app-all-icons
                    [style.cursor]="'pointer'"
                    cdkDragHandle
                    data-qa="drag-metric"
                    class="icon-size-1p5 pd-top-0p6"
                    [iconNameAndStyling]="'two-lines-six-dots.svg'">
                  </app-all-icons>
                  @if (metricGroupType === 'Numbers with balances') {
                    <app-selector
                      data-qa="select-metric-sign"
                      class="min-w-[15.5rem]"
                      [data]="signs"
                      [field]="'sign'"
                      [selectedItem]="metric.value.dataProps"
                      [isNotInTable]="true"
                      (itemEmitter)="setSign(metric, $event)">
                    </app-selector>
                  } @else {
                    <app-selector
                      data-qa="select-metric-data-type"
                      class="min-w-[15.5rem]"
                      [data]="dataTypes"
                      [field]="'displayName'"
                      [selectedItem]="getTypeSelectedItem(metric)"
                      [isNotInTable]="true"
                      (itemEmitter)="setType(metric, $event)">
                    </app-selector>
                  }
                  <app-input
                    data-qa="input-metric-name"
                    class="w-full"
                    formControlName="name"
                    placeholder="Metric name"
                    [additionalClass]="!metric.valid ? 'error' : ''"
                    [bottomText]="metricErrorMessage(metric)">
                  </app-input>
                  <div class="centered-row-container">
                    <app-all-icons
                      data-qa="copy-metric"
                      class="icon-size-1p5 pd-top-0p6 clickable"
                      [iconNameAndStyling]="'copy-outline.svg'"
                      (click)="copyMetricGroup(i)">
                    </app-all-icons>
                  </div>
                  <div class="centered-row-container">
                    <app-all-icons
                      data-qa="delete-metric"
                      class="icon-size-1p5 pd-top-0p6 clickable"
                      [iconNameAndStyling]="'delete.svg'"
                      (click)="deleteMetricFromMetricGroup(i)">
                    </app-all-icons>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <app-button
          data-qa="add-metric"
          class="width-100pcnt"
          [type]="'grey-dashed'"
          [iconName]="'plus.svg'"
          [size]="'small'"
          [showIcon]="'left'"
          [bordersSquaredShape]="'full'"
          [additionalClasses]="'width-100pcnt'"
          (buttonClick)="addMetric(null)">
          Metric
        </app-button>
        @if (metricGroupType === 'Numbers with balances') {
          <div class="space-between-horizontal-centered row-gap-1 w-[45rem]" [formGroup]="ending">
            <app-checkbox
              data-qa="checkbox-ending-metric"
              class="w-[1.5rem]"
              formControlName="isSelected"
              (checkBoxClicked)="handleChange(ending, starting, false)">
            </app-checkbox>
            <app-input
              class="w-[17.75rem]"
              [placeholder]="'Sum (current period)'"
              [prefixFirstIcon]="'sum.svg'"
              [additionalClass]="'disabled'"
            />
            <div  class="w-[30rem]">
              <app-input
                data-qa="input-ending-name"
                class="w-full"
                formControlName="name"
                placeholder="Ending name"
                [additionalClass]="!ending.value?.isSelected ? 'disabled' : ''">
              </app-input>
            </div>
          </div>
        }
        @if (modalType === 'create' && showEnableForAllCompanies) {
          <div class="grey-line"></div>
          <div class="flex">
            <app-switcher
              data-qa="enable-for-all-companies-checkbox"
              class="medium-switcher"
              [checked]="enableForAllCompanies"
              [rightText]="'Enable this metric group in all companies'"
              (checkedChanged)="toggleEnableForAllCompanies($event)">
            </app-switcher>
          </div>
        }
      </div>
    }
  }
  @if (showThinkTwiceModalForGroup) {
    <app-modal-dialog
      [header]="'Delete metric group'"
      [addAdditionalText]="true"
      [mainText]="modalText.deleteGroupDescription"
      (isConfirmed)="deleteGroup($event)">
    </app-modal-dialog>
  }

  @if (metricIndexForDeleteThinkTwiceModal !== undefined) {
    <app-modal-dialog
      [header]="'Delete metric'"
      [addAdditionalText]="true"
      [mainText]="modalText.deleteMetricDescription"
      (isConfirmed)="deleteMetricFromMetricGroupAndCloseModal($event)">
    </app-modal-dialog>
  }

</app-modal-container>
